import React, { useState, useEffect, useMemo } from "react";
import { getData } from "../../../../../services/library";
import { UrlApi } from "../../../../../services/apirest";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";
import { Container, Chip, Typography, Box, alpha, ThemeProvider, createTheme } from "@mui/material";
import moment from "moment";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

export default function HistorialPreciosLista({ params }) {
    const [precios, setPrecios] = useState([]);
    const [productos, setProductos] = useState([]);

    useEffect(() => {
        if (!!params && (!params?.productos && !!params?.id_cliente)) {
            fetch(UrlApi + `/direccionesentrega/allproductos/${params.id_cliente}/${params.nro_cliente}`)
                .then(res => res.json())
                .then(data => setProductos(data.map((item) => item.id_producto)))
                .catch(error => console.log(error))
        } else {
            setProductos([params?.productos]);
        }
    }, [params])


    useEffect(() => {
        if (!!productos?.length > 0) {
            getData(`/lista_precios/historial/${params.id_empresa}/${params.id_sucursal}/${params.id_segmento}/${productos}`, setPrecios)
        }
    }, [productos])

    const columns = useMemo(
        () => [
            {
                accessorKey: "precio_litro_sin_iva", //access nested data with dot notation
                header: "lt sin iva",
                size: 120,
                Cell: ({ cell, row }) => (
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: 13.5,
                            color: palette.textSecondary,
                            fontFeatureSettings: '"tnum"',
                            fontVariantNumeric: "tabular-nums",
                        }}
                    >
                        ${cell.getValue()}
                    </Typography>
                ),
            },
            {
                accessorKey: "precio_litro_con_iva",
                header: "lt con iva",
                size: 120,
                Cell: ({ cell, row }) => (
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: 13.5,
                            color: palette.textSecondary,
                            fontFeatureSettings: '"tnum"',
                            fontVariantNumeric: "tabular-nums",
                        }}
                    >
                        ${cell.getValue()}
                    </Typography>
                ),
            },
            {
                accessorKey: "precio_kilo_sin_iva",
                header: "kg sin iva",
                size: 120,
                Cell: ({ cell, row }) => (
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: 13.5,
                            color: palette.textSecondary,
                            fontFeatureSettings: '"tnum"',
                            fontVariantNumeric: "tabular-nums",
                        }}
                    >
                        ${cell.getValue()}
                    </Typography>
                ),
            },
            {
                accessorKey: "precio_kilo_con_iva",
                header: "kilo con iva",
                size: 120,
                Cell: ({ cell, row }) => (
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: 13.5,
                            color: palette.textSecondary,
                            fontFeatureSettings: '"tnum"',
                            fontVariantNumeric: "tabular-nums",
                        }}
                    >
                        ${cell.getValue()}
                    </Typography>
                ),
            },
            {
                accessorKey: "vigencia",
                header: "vigencia",
                size: 120,
                Cell: ({ cell, row }) => (
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: 13,
                            color: palette.textSecondary,
                        }}
                    >
                        {moment(cell.getValue()).format("DD/MM/YYYY")}
                    </Typography>
                ),
            },
            {
                accessorKey: "fin_vigencia",
                header: "fin vigencia ",
                size: 120,
                Cell: ({ cell, row }) => (
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: 13,
                            color: palette.textSecondary,
                        }}
                    >
                        {!!cell.getValue() ? moment(cell.getValue()).format("DD/MM/YYYY") : "—"}
                    </Typography>
                ),
            },
            {
                accessorKey: "aumento_en_pesos",
                header: "aumento en $",
                size: 120,
                Cell: ({ row }) => {
                    const aumento_en_pesos = row.original.aumento_en_pesos;
                    const aumento_en_porcentaje = row.original.aumento_en_porcentaje;

                    if (aumento_en_pesos) {
                        return (
                            <Chip
                                icon={<ArrowUpwardIcon sx={{ fontSize: "14px !important" }} />}
                                label={`$ ${aumento_en_pesos}`}
                                size="small"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: 12,
                                    background: alpha(palette.success, 0.1),
                                    color: "#059669",
                                    border: `1px solid ${alpha(palette.success, 0.2)}`,
                                    "& .MuiChip-icon": { color: "#059669" },
                                }}
                            />
                        );
                    } else if (aumento_en_porcentaje) {
                        return (
                            <Chip
                                icon={<TrendingUpIcon sx={{ fontSize: "14px !important" }} />}
                                label={`${aumento_en_porcentaje}%`}
                                size="small"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: 12,
                                    background: alpha("#8b5cf6", 0.1),
                                    color: "#7c3aed",
                                    border: `1px solid ${alpha("#8b5cf6", 0.2)}`,
                                    "& .MuiChip-icon": { color: "#7c3aed" },
                                }}
                            />
                        );
                    }

                    return (
                        <Typography sx={{ color: palette.textSecondary, fontSize: 13 }}>
                            —
                        </Typography>
                    );
                }
            },

        ],
        []
    );

    const palette = {
        primary: "#1976d2",
        accent: "#2196f3",
        success: "#10b981",
        text: "#1e293b",
        textSecondary: "#64748b",
        white: "#ffffff",
        surfaceAlt: "#f8fafc",
        border: "#e2e8f0",
    };


    const theme = createTheme({
        palette: {
            primary: {
                main: palette.primary,
            },
        },
        typography: {
            fontFamily: "inherit",
        },
    });


    const Tabla = ({ precios }) => {
        const initialState = {
            density: "compact",
            showGlobalFilter: true,
            pagination: {
                pageSize: 10,
                pageIndex: 0,
            },
        };

        const tableHeadCellProps = {
            sx: {
                backgroundColor: "#164e63",
                color: alpha("#fff", 0.9),
                fontWeight: 700,
                fontSize: 12,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                py: 1.8,
                px: 2,
                whiteSpace: "nowrap",
                borderBottom: "none",
                "& .MuiTableSortLabel-root": {
                    color: "inherit !important",
                },
                "& .MuiTableSortLabel-icon": {
                    color: "inherit !important",
                },
            },
        }

        const muiSearchTextFieldProps = {
            placeholder: "Buscar..",
            sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
            variant: "outlined",
            color: "primary",
            size: "small",
        };

        const tableBodyRowProps = ({ row }) => ({
            sx: {
                background:
                    row.index === 0
                        ? alpha("#164e63", 0.04)
                        : row.index % 2 === 0
                            ? "#ffffff"
                            : "#f8fafc",
                transition: "all 0.2s",
                "&:hover": {
                    background: `${alpha("#164e63", 0.07)} !important`,
                },
            },
        })

        const muiTableBodyCellProps = {
            sx: {
                py: 1.5,
                px: 2,
                borderColor: palette.border,
            },
        }

        const muiTopToolbarProps = {
            sx: {
                background: palette.white,
                borderBottom: `1px solid ${palette.border}`,
                px: 2,
                py: 1,
            },
        }

        const muiBottomToolbarProps = {
            sx: {
                background: palette.white,
                borderTop: `1px solid ${palette.border}`,
            }
        }

       

        const renderTopToolbarCustomActions = () => (
            <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              gap: 1.5,
              background: `linear-gradient(135deg, ${alpha(palette.primary, 0.08)} 0%, ${alpha(palette.accent, 0.04)} 100%)`,
              borderRadius: 2,
              px: 2,
              py: 1,
              border: `1px solid ${alpha(palette.primary, 0.12)}`,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 36,
                height: 36,
                borderRadius: 1.5,
                background: `linear-gradient(135deg, ${palette.primary} 0%, ${palette.accent} 100%)`,
                boxShadow: `0 2px 8px ${alpha(palette.primary, 0.3)}`,
              }}
            >
              <LocalOfferIcon sx={{ color: "#fff", fontSize: 20 }} />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography
                sx={{
                  fontWeight: 700,
                  color: palette.text,
                  fontSize: 15,
                  lineHeight: 1.2,
                  letterSpacing: "-0.01em",
                }}
              >
                {precios[0]?.producto_nombre}
              </Typography>
              {/* <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <InventoryIcon sx={{ fontSize: 12, color: palette.textSecondary }} />
                <Typography
                  sx={{
                    fontSize: 11,
                    color: palette.textSecondary,
                    fontWeight: 500,
                  }}
                >
                  Historial de precios
                </Typography>
              </Box> */}
            </Box>
            <Chip
              label={`${precios.length} registros`}
              size="small"
              sx={{
                ml: 1,
                fontWeight: 600,
                fontSize: 11,
                height: 24,
                background: alpha(palette.primary, 0.1),
                color: palette.primary,
                border: `1px solid ${alpha(palette.primary, 0.2)}`,
              }}
            />
          </Box>
        )

        return (
            <>
                <ThemeProvider theme={theme}>
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            overflowX: "hidden",
                            py: 2,
                            width: "100%",
                        }}
                    >

                        <MaterialReactTable
                            muiSearchTextFieldProps={muiSearchTextFieldProps}
                            localization={MRT_Localization_ES}
                            muiTablePaperProps={{
                                elevation: 1,
                                sx: {
                                    borderRadius: 3,
                                    border: `1px solid ${palette.border}`,
                                    overflow: "hidden",
                                },
                            }}
                            tableHeadCellProps={tableHeadCellProps}
                            tableBodyRowProps={tableBodyRowProps}
                            muiTableBodyCellProps={muiTableBodyCellProps}
                            muiTopToolbarProps={muiTopToolbarProps}
                            muiBottomToolbarProps={muiBottomToolbarProps}
                            renderTopToolbarCustomActions={renderTopToolbarCustomActions}
                            columns={columns}
                            data={precios}
                            enableColumnFilterModes={false}
                            enableColumnOrdering={false}
                            enableGrouping={false}
                            initialState={initialState}
                            enableRowSelection={false}
                            enableHiding={false}
                            muiTableHeadCellProps={tableHeadCellProps}
                            enableExpandAll={false}
                            enableColumnActions={false}
                            enableColumnFilters={false}
                            enableDensityToggle={false}
                        />
                    </Box>
                </ThemeProvider>
            </>
        )
    }

    return (
        <div>
            <Container maxWidth="xl" sx={{ pt: 2 }}>
                {productos && productos.map((producto) => {
                    const preciosPorProducto = precios.filter((precio) => precio.id_producto == producto)
                    return <Tabla precios={preciosPorProducto} producto={producto} />
                })}
            </Container>
        </div>
    );
}

